import OkC from "shared/util/OkcApi";

export function fetchPassionsPicked(data) {
	return OkC.get("/passions", {
		api: 1,
		data,
	});
}

export function fetchPassionsList(data) {
	return OkC.get("/passions/available", {
		api: 1,
		data,
	});
}

export function savePassionsPicked({ passionsPicked, options = {} }) {
	return OkC.post("/passions", {
		api: 1,
		data: {
			passionsPicked,
			...options,
		},
	});
}



// WEBPACK FOOTER //
// ./src/apps/passions_picker/util/web.js